import { createSelector } from 'reselect';
import { AppState } from './../../model';

export const getSelected = ({ selectedSegment }: AppState) => selectedSegment;

export const isSelected = (orderId: string) =>
  createSelector(
    getSelected,
    ({ id }): boolean => id === orderId,
  );
